/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, withRouter } from "react-router-dom";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Container,
    Button,
} from "reactstrap";

import routes from "routes.js";
import AuthService from "services/auth.service";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Deco from "security/decrypt"
import ToolSelector from "components/ToolSelector/ToolSelector"
import PageContext from "contexts/PageContext"

class Header extends React.Component {
    static contextType = PageContext;

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            dropdownOpen: false,
            color: "transparent",
            fullname: ""
        };
        this.toggle = this.toggle.bind(this);
        this.dropdownToggle = this.dropdownToggle.bind(this);
        this.sidebarToggle = React.createRef();
    }
    toggle() {
        if (this.state.isOpen) {
            this.setState({
                color: "transparent",
            });
        } else {
            this.setState({
                color: "dark",
            });
        }
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }
    dropdownToggle(e) {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
    getBrand() {
        return this.props.title;
    }
    openSidebar() {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    }
    // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
    updateColor() {
        if (window.innerWidth < 993 && this.state.isOpen) {
            this.setState({
                color: "dark",
            });
        } else {
            this.setState({
                color: "transparent",
            });
        }
    }
    componentDidMount() {
        window.addEventListener("resize", this.updateColor.bind(this));
        this.getFullNameUser()
    }
    componentDidUpdate(e) {
        if (
            window.innerWidth < 993 &&
            e.history.location.pathname !== e.location.pathname &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            this.sidebarToggle.current.classList.toggle("toggled");
        }
    }

    logout() {
        AuthService.logout()
    }

    getFullNameUser() {
        const user = JSON.parse(Deco(localStorage.getItem('user')));
        this.setState({ fullname: user.fullname })
    }

    handleGoBack = () => {
        const { backUrl } = this.context;
        if (backUrl) {
            this.props.history.push(backUrl);
        } else {
            this.props.history.goBack();
        }
    }

    renderBreadcrumb() {
        const { breadcrumbItems, hasBreadcrumb } = this.context;

        if (!hasBreadcrumb) {
            return (
                <span style={{
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#1a1a1a',
                    letterSpacing: '-0.3px'
                }}>
                    {this.getBrand()}
                </span>
            );
        }

        return (
            <div className="d-flex align-items-center">
                <Button
                    size="sm"
                    onClick={this.handleGoBack}
                    style={{
                        marginRight: '12px',
                        fontWeight: '600',
                        borderRadius: '20px',
                        padding: '6px 14px',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, #3498db 0%, #2c3e50 100%)',
                        border: 'none',
                        color: '#fff',
                        boxShadow: '0 2px 8px rgba(52,152,219,0.3)'
                    }}
                >
                    <i className="fas fa-chevron-left" style={{ marginRight: '4px' }}></i>
                    Quay lại
                </Button>
                <span style={{ fontSize: '14px', color: '#525f7f' }}>
                    {breadcrumbItems.map((item, index) => (
                        <span key={index}>
                            {item.to && index !== breadcrumbItems.length - 1 ? (
                                <Link to={item.to} style={{ color: '#3498db', textDecoration: 'none', fontWeight: '500' }}>{item.label}</Link>
                            ) : (
                                <span style={{ fontWeight: index === breadcrumbItems.length - 1 ? '700' : 'normal', color: index === breadcrumbItems.length - 1 ? '#2c3e50' : '#525f7f' }}>
                                    {item.label}
                                </span>
                            )}
                            {index < breadcrumbItems.length - 1 && <span style={{ margin: '0 8px', color: '#adb5bd' }}>/</span>}
                        </span>
                    ))}
                </span>
            </div>
        );
    }

    render() {
        const { hasBreadcrumb } = this.context || {};

        return (
            <Navbar
                color={
                    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                        ? "dark"
                        : this.state.color
                }
                expand="lg"
                className={
                    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                        ? "navbar-absolute fixed-top"
                        : "navbar-absolute fixed-top " +
                        (this.state.color === "transparent" ? "navbar-transparent " : "")
                }
                style={{
                    background: this.state.color === "transparent" ? 'linear-gradient(135deg, #e4e3e0 0%, #d3d2cf 100%)' : undefined,
                    padding: '14px 5px'
                }}
            >
                <Container fluid>
                    <div className="navbar-wrapper">
                        <div className="navbar-toggle">
                            <button
                                type="button"
                                ref={this.sidebarToggle}
                                className="navbar-toggler"
                                onClick={() => this.openSidebar()}
                            >
                                <span className="navbar-toggler-bar bar1" />
                                <span className="navbar-toggler-bar bar2" />
                                <span className="navbar-toggler-bar bar3" />
                            </button>
                        </div>
                        {this.renderBreadcrumb()}
                        {/* Only show ToolSelector on Update, Plugin, Dll, Language pages */}
                        {!hasBreadcrumb && (window.location.pathname.includes('/update') ||
                            window.location.pathname.includes('/plugin') ||
                            window.location.pathname.includes('/dll') ||
                            window.location.pathname.includes('/language')) && (
                                <div style={{ marginLeft: '20px' }}>
                                    <ToolSelector />
                                </div>
                            )}
                    </div>
                    <NavbarToggler onClick={this.toggle}>
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                        <span className="navbar-toggler-bar navbar-kebab" />
                    </NavbarToggler>
                    <Collapse
                        isOpen={this.state.isOpen}
                        navbar
                        className="justify-content-end"
                    >
                        <Nav navbar style={{ alignItems: 'center', gap: '16px' }}>
                            <NavItem>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '7px 16px',
                                    borderRadius: '20px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                }}>
                                    <i className="fas fa-user-circle" style={{ fontSize: '16px', color: '#3498db' }}></i>
                                    <span style={{
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#2c3e50'
                                    }}>
                                        {this.state.fullname}
                                    </span>
                                </div>
                            </NavItem>
                            <NavItem>
                                <div
                                    onClick={() => this.logout()}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '7px 16px',
                                        borderRadius: '20px',
                                        cursor: 'pointer',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        color: '#fff',
                                        background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                                        boxShadow: '0 2px 8px rgba(231,76,60,0.3)',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseOver={e => { e.currentTarget.style.opacity = '0.85'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                                    onMouseOut={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                >
                                    <i className="fas fa-sign-out-alt" style={{ fontSize: '13px' }}></i>
                                    Đăng xuất
                                </div>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        );
    }
}

export default withRouter(Header);
